import { SuggestionsEditor } from '.'

export const DISABLE_SUGGESTING: WeakMap<SuggestionsEditor, boolean> = new WeakMap()
export const IsInUndo: WeakMap<SuggestionsEditor, boolean> = new WeakMap()
export const IsInRedo: WeakMap<SuggestionsEditor, boolean> = new WeakMap()
